export default __webpack_public_path__ + "static/media/UNMISS_SRSG_visits_leer_and_thonyor.f25d2858.jpg";